// src/utils/routines.js — streak and progress calculations

const _TODAY = new Date().toISOString().slice(0, 10);

function getISOWeek(dateStr) {
  const d = new Date(dateStr + 'T12:00:00');
  const jan4 = new Date(d.getFullYear(), 0, 4);
  const startOfWeek1 = new Date(jan4);
  startOfWeek1.setDate(jan4.getDate() - ((jan4.getDay() + 6) % 7));
  const weekNum = Math.floor((d - startOfWeek1) / (7 * 86400000)) + 1;
  return `${d.getFullYear()}-W${String(weekNum).padStart(2, '0')}`;
}

function addDaysStr(dateStr, n) {
  const d = new Date(dateStr + 'T12:00:00');
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
}

function getWeekOfDate(dateStr) {
  return getISOWeek(dateStr);
}

function getPrevWeek(weekStr) {
  // weekStr: "2026-W15" → get any date in that week, subtract 7 days
  const [year, wStr] = weekStr.split('-W');
  const weekNum = parseInt(wStr);
  // Jan 4 of year is always in week 1
  const jan4 = new Date(parseInt(year), 0, 4);
  const startOfWeek1 = new Date(jan4);
  startOfWeek1.setDate(jan4.getDate() - ((jan4.getDay() + 6) % 7));
  const targetMonday = new Date(startOfWeek1);
  targetMonday.setDate(startOfWeek1.getDate() + (weekNum - 1) * 7);
  targetMonday.setDate(targetMonday.getDate() - 7);
  return getISOWeek(targetMonday.toISOString().slice(0, 10));
}

function streakDaily(history, targetCount) {
  // Group by day
  const counts = {};
  history.forEach(h => {
    const day = h.slice(0, 10);
    counts[day] = (counts[day] || 0) + 1;
  });

  let streak = 0;
  let cursor = addDaysStr(_TODAY, -1); // start from yesterday
  for (let i = 0; i < 365; i++) {
    const c = counts[cursor] || 0;
    if (c >= targetCount) {
      streak++;
      cursor = addDaysStr(cursor, -1);
    } else {
      break;
    }
  }
  return streak;
}

function streakWeekly(history, targetCount) {
  // Group by ISO week
  const counts = {};
  history.forEach(h => {
    const week = getISOWeek(h.slice(0, 10));
    counts[week] = (counts[week] || 0) + 1;
  });

  let streak = 0;
  let cursor = getPrevWeek(getISOWeek(_TODAY)); // start from last week
  for (let i = 0; i < 104; i++) {
    const c = counts[cursor] || 0;
    if (c >= targetCount) {
      streak++;
      cursor = getPrevWeek(cursor);
    } else {
      break;
    }
  }
  return streak;
}

export function computeStreak(routine) {
  const target = routine.target || { count: 1, unit: 'day' };
  const history = routine.history || [];
  if (history.length === 0) return 0;
  if (target.unit === 'week') return streakWeekly(history, target.count);
  return streakDaily(history, target.count);
}

export function progressThisUnit(routine) {
  const target = routine.target || { count: 1, unit: 'day' };
  const history = routine.history || [];
  if (target.unit === 'week') {
    const thisWeek = getISOWeek(_TODAY);
    return history.filter(h => getISOWeek(h.slice(0, 10)) === thisWeek).length;
  }
  return history.filter(h => h.slice(0, 10) === _TODAY).length;
}
